export interface IFeatureFlags {
    organizations: boolean;
    employees: boolean;
    messages: boolean;
    employeeTalks: boolean;
    landingPage: boolean;
    game: boolean;
    opportunities: boolean;
}

export const defaultFeatureFlags: IFeatureFlags = {
    organizations: true,
    employees: true,
    messages: false,
    employeeTalks: true,
    landingPage: false,
    game: false,
    opportunities: false,
};
